export default "__VITE_ASSET__g_c99PSn__"